module.exports = __webpack_public_path__ + "static/orbitkey-05dc1e090d779f74e738b757d0623409.png";